import { Button, DatePicker, Form, Grid, Input, message, Select } from 'antd';
import { ContentFilters } from 'components';
import { TransectionApiServices } from 'features/transaction_list/api/transection-api.service';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { payFormatDate } from 'utils/payload-date-';

import { WaitingFilterFormField, WaitingFilterFormValues } from './types';

const { useBreakpoint } = Grid;

type UsersFilterFormProps = {
    formId: string;
    handleFilter: (values: WaitingFilterFormValues) => void;
    initialValues: WaitingFilterFormValues;
    closeModal?: () => void;
};

export const WaitingFilterForm = ({
    formId,
    handleFilter,
    initialValues,
    closeModal,
}: UsersFilterFormProps) => {
    const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
    const [form] = Form.useForm<WaitingFilterFormValues>();
    const { t } = useTranslation();
    const screens = useBreakpoint();
    const onReset = () => {
        form.resetFields();
        handleFilter({ ...initialValues });
    };

    const onFinish = (formValues: WaitingFilterFormValues) => {
        const formattedValues = {
            ...formValues,
            [WaitingFilterFormField.BookingDate]: formValues?.bookingDate && payFormatDate(formValues?.bookingDate),
        };
        handleFilter(formattedValues);
        closeModal?.();
    };


    const [allYear, setAllYear] = useState({
        items: []
    })


    const getYear = async () => {
        try {
            const apires = await TransectionApiServices().getDropDownList(`Flag=${'YEAR'}`)
            setAllYear(apires as any)
        } catch (error) {
            message.error('')
        }
    }
    useEffect(() => {
        getYear();
    }, [])

    const reverseData = [...allYear.items].reverse()

    return (

        <Form<WaitingFilterFormValues>
            id={formId}
            name={formId}
            className='filters-form'
            form={form}
            layout='vertical'
            onFinish={onFinish}
            initialValues={initialValues}
            onFinishFailed={() => {
                setValidateTrigger(['onChange']);
            }}
            validateTrigger={validateTrigger}
        >
            <ContentFilters.FormItemsWrapper>

                <div className='invoice_list'>
                    <Form.Item
                        label={'Year'}
                        name={WaitingFilterFormField.Year}
                    >
                        <Select
                            // defaultValue="2024"
                            options={[
                                { label: 'All', value: '' }, // Add the "All" option
                                ...reverseData.map((res: any) => ({ label: res.Text, value: res.Id })),
                            ]}
                        />
                    </Form.Item>

                    <Form.Item

                        label={'Invoice Number'}
                        name={WaitingFilterFormField.InvoiceId}

                    >
                        <Input placeholder={'Enter Invoice Number'} />
                    </Form.Item>
                    <Form.Item
                        label={'Name'}
                        name={WaitingFilterFormField.Name}
                    >
                        <Input placeholder={'Enter Name'} />
                    </Form.Item>
                     <Form.Item
                        label={'Event Name'}
                        name={WaitingFilterFormField.Event_name}
                    >
                        <Input placeholder={'Enter Event Name'} />
                    </Form.Item>

                    <Form.Item
                        label={'Mobile'}
                        name={WaitingFilterFormField.MobileNo}
                    >
                        <Input placeholder={'Enter Mobile No'} />
                    </Form.Item>


                    <Form.Item
                        label={'EMAIL'}
                        name={WaitingFilterFormField.Email}
                    >
                        <Input placeholder={'Enter Email'} />
                    </Form.Item>

                    <Form.Item
                        label={'Pay Type'}
                        name={WaitingFilterFormField.paymentMethod}
                    >
                        <Select
                            defaultValue="Select Pay Type"

                            options={[
                                { value: 'Cash', label: 'Cash' },
                                { value: 'Card', label: 'Card' },
                                { value: 'Wallet', label: 'Wallet' },
                                { value: 'Bank Transfer', label: 'Bank Transfer' },
                                { value: 'Knet', label: 'Knet' },
                                { value: 'AMEX', label: 'AMEX' },
                                { value: 'Mada', label: 'Mada' },
                                { value: 'ApplePay', label: 'Apple Pay' },
                                { value: 'Omani', label: 'Omani' },
                                { value: 'Waiting', label: 'Waiting' },
                            ]}
                        />
                    </Form.Item>

                    <Form.Item
                        label={'Transaction Status'}
                        name={WaitingFilterFormField.TransactionStatus}
                    >
                        <Select
                            defaultValue="Select Transaction Status"
                            style={{ width: 180 }}
                            options={[
                                { value: 'Captured', label: 'Captured' },
                                { value: 'uncaptured', label: 'Uncaptured' },
                                { value: 'reserved', label: 'Reserved' },
                                { value: 'PENDING', label: 'PENDING' },
                                { value: 'Error', label: 'Error' },
                                { value: 'rejectbyadmin', label: 'Reject by Admin' },
                            ]}
                        />
                    </Form.Item>
                    <Form.Item
                        label={'Booking Date'}
                        name={WaitingFilterFormField.BookingDate}
                    >
                        <DatePicker />
                    </Form.Item>


                    <Form.Item
                        label={'Auth Id'}
                        name={WaitingFilterFormField.AuthId}
                    >
                        <Input placeholder={'Auth Id'} />
                    </Form.Item>

                    <Form.Item
                        label={'Transaction Id'}
                        name={WaitingFilterFormField.TransactionId}
                    >
                        <Input placeholder={'Enter Transaction Id'} />
                    </Form.Item>


                    <Form.Item
                        label={'Reference no'}
                        name={WaitingFilterFormField.RefrenceNumber}
                    >
                        <Input placeholder={'Enter Reference No'} />
                    </Form.Item>
                    <Form.Item
                        label={'Payments Currency'}
                        name={WaitingFilterFormField.Currency}
                    >
                        <Select
                            defaultValue="Select Payments Currency"

                            options={[
                                { value: 'KD', label: 'KD' },
                                { value: 'SAR', label: 'SAR' },
                                { value: 'OMR', label: 'OMR' },
                                { value: 'USD', label: 'USD' },
                                { value: 'QAR ', label: 'QAR ' },
                            ]}
                        />
                    </Form.Item>

                    {screens.lg && (
                        <ContentFilters.ButtonsWrapper className='filter_btn waiting_list'>
                            <Button type='primary' htmlType='submit'>
                                {t('common.buttons.filter', { count: 1 })}
                            </Button>
                            <Button onClick={onReset}>{t('common.buttons.reset')}</Button>
                        </ContentFilters.ButtonsWrapper>
                    )}

                </div>

            </ContentFilters.FormItemsWrapper>

        </Form>
    );
};
